export const messagesSettings = {
    pt: {
        message:{
            api: "API",
            campaignsPriority: "Prioridade de Campanhas",
            captiveForms: "Tipos de Cadastro",
            confirmNewPassword: "Confirmar nova senha",
            currentPassword: "Senha atual",
            emailChange: "Alteração de email",
            emailChangeHint: "Ao mudar o seu e-mail você será redirecionado e precisará refazer o seu login.",
            integrations: "Integrações",
            newPassword: "Nova senha",
            redefinePassword: "Redefinir senha",
            registrationScreen: "Tela de cadastro",
            setBusinessHours: "Horário de Funcionamento",
            termsOfUse: "Termos de uso",
            captiveEdit: "Tela de Cadastro",
            devicesQuantity: "Quantidade de equipamentos"
        }
    },
    es: {
        message:{
            api:"API",
            campaignsPriority:"Prioridad de la campaña",
            captiveForms: "Tipos de Registro",
            confirmNewPassword:"Confirmar una nueva contraseña",
            currentPassword:"Contraseña actual",
            emailChange:"Cambio de correo electrónico",
            emailChangeHint:"Al cambiar su correo electrónico, será redirigido y deberá rehacer su inicio de sesión",
            integrations:"Integraciones",
            newPassword:"Nueva contraseña",
            redefinePassword:"Redefinir contraseña",
            registrationScreen:"Pantalla de registro",
            setBusinessHours: "Horario Comercial",
            termsOfUse:"Terminos de uso",
            captiveEdit: "Pantalla de registro",
            devicesQuantity: "Cantidad de equipo"
        }
    },
    en: {
        message:{
            api: "API",
            campaignsPriority: "Campaigns Priority",
            captiveForms: "Registration Types",
            confirmNewPassword: "Confirm new password",
            currentPassword: "Current password",
            emailChange: "Email change",
            emailChangeHint: "When changing your email you will be redirected and will need to re-login.",
            integrations: "Integrations",
            newPassword: "New password",
            redefinePassword: "Redefine password",
            registrationScreen: "Registration screen",
            setBusinessHours: "Business hours",
            termsOfUse: "Terms of use",
            captiveEdit: "Registration Screen",
            devicesQuantity: "Quantity of equipment"
        }
    }
}
